import classNames from "classnames";
import { useMemo } from "react";

import type { MediaDataFragment } from "../graphql/types";
import { MediaFile } from "./MediaFile";
import { MediaImage } from "./MediaImage";
import { Video } from "./Video";

export interface MediaProps {
  media: MediaDataFragment;
  prefer?: "cover" | "contain";
  visible: boolean;
  prefetch?: boolean;
  className?: string;
  sizes: ([string, string] | [string])[];
  size: {
    width: number;
    height: number;
  } | null;
}

export function Media(props: MediaProps) {
  const { media, visible, className, size, sizes, prefer, prefetch } = props;

  const shouldCover = useMemo(() => {
    const { width: mediaWidth, height: mediaHeight } = media;

    if (!size || !mediaWidth || !mediaHeight) {
      if (prefer === "contain") {
        return false;
      } else {
        return true;
      }
    }

    return (
      mediaWidth >= size.width &&
      mediaHeight >= size.height &&
      Math.abs(mediaWidth / mediaHeight - size.width / size.height) < 0.01
    );
  }, [media, size, prefer]);

  return (
    <div className={classNames("lookbook--media", className)}>
      {media.__typename === "MediaVideo" ? (
        <Video
          visible={visible}
          video={media}
          className={classNames({
            "object-cover": shouldCover,
            "object-contain": !shouldCover,
          })}
        />
      ) : media.__typename === "MediaImage" ? (
        <MediaImage
          visible={visible}
          prefetch={prefetch}
          image={media}
          sizes={sizes.map((entry) => entry.join(" ")).join(", ")}
          className={classNames({
            "object-cover w-full h-full": shouldCover,
            "object-contain": !shouldCover,
          })}
        />
      ) : (
        <MediaFile
          visible={visible}
          prefetch={prefetch}
          file={media}
          className={classNames({
            "object-cover": shouldCover,
            "object-contain": !shouldCover,
          })}
        />
      )}
    </div>
  );
}
